document.addEventListener("DOMContentLoaded", () => {
  // Funkcja wykonująca wyrównanie wysokości
  const alignElements = () => {
    // Sprawdź, czy szerokość okna jest większa niż 767px
    if (window.innerWidth < 1250) {
      // Znajdź wszystkie elementy z atrybutem data-align-others-of-type
      const elements = document.querySelectorAll("[data-align-others-of-type]");

      // Obiekt do przechowywania grup elementów według ich typu
      const groups = {};

      elements.forEach((element) => {
        // Pobierz typ elementu (wartość atrybutu data-align-others-of-type)
        const type = element.getAttribute("data-align-others-of-type");

        // Jeśli typ nie istnieje w obiekcie groups, utwórz nową tablicę
        if (!groups[type]) {
          groups[type] = [];
        }

        // Dodaj element do odpowiedniej grupy
        groups[type].push(element);
      });

      // Ustaw wysokość dla każdego typu
      for (const type in groups) {
        const group = groups[type];

        // Znajdź najwyższy element w grupie
        const maxHeight = Math.max(...group.map((el) => el.offsetHeight));

        // Ustaw wysokość wszystkich elementów w grupie na wysokość najwyższego elementu
        group.forEach((el) => {
          el.style.height = `${maxHeight}px`;
        });
      }
    } else {
      // Resetuj wysokość elementów, gdy szerokość jest mniejsza lub równa 767px
      document.querySelectorAll("[data-align-others-of-type]").forEach((el) => {
        el.style.height = "";
      });
    }
  };

  // Wywołaj funkcję przy załadowaniu dokumentu
  alignElements();

  // Dodaj listener, aby sprawdzać zmianę rozmiaru okna
  window.addEventListener("resize", alignElements);
});
